import { useNavigate } from "react-router-dom";
import { Client } from "../../../models/client";

const IconChevron = () => (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
    <path d="M3 1l4 4-4 4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const KIND_LABELS: Record<string, string> = {
  lender: "Lender",
  agent: "Agent",
  other: "Other",
};

function ClientRow({ client }: { client: Client }) {
  const navigate = useNavigate();

  if (!client?.id) return null;

  return (
    <tr onClick={() => navigate(`/client/${client.id}`)} style={{ cursor: "pointer" }}>
      <td>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <div style={{ width: 32, height: 32, borderRadius: 8, background: "var(--cream)", display: "grid", placeItems: "center", fontFamily: "var(--serif)", fontSize: 13, color: "var(--maroon)", fontWeight: 600, flexShrink: 0 }}>
            {client.name?.[0] || "?"}
          </div>
          <span style={{ fontWeight: 500 }}>{client.name || "—"}</span>
        </div>
      </td>
      <td>
        {client.kind && (
          <span className={`p-pill ${client.kind === "lender" ? "gold" : client.kind === "agent" ? "green" : "gray"}`}>
            <span className="dot" />
            {KIND_LABELS[client.kind] || client.kind}
          </span>
        )}
      </td>
      <td style={{ color: "var(--ink-soft)", fontFamily: "var(--mono)", fontSize: 13 }}>
        {client.email || "—"}
      </td>
      <td>
        <span style={{ color: "var(--ink-soft)" }}><IconChevron /></span>
      </td>
    </tr>
  );
}

export default ClientRow;
